import MultipleChoiceForm, { ChoiceInput } from './MultipleChoiceForm';

export { ChoiceInput };
export default MultipleChoiceForm;
